import { SectionIntro } from "@/components/site/SectionHead";
import { Reveal } from "@/components/site/motion";

export const Principles = () => (
  <section id="principles" className="shell py-16 sm:py-20" data-testid="principles-section" data-analytics-section="principles">
    <SectionIntro label="How we build" title="Two simple rules." />
    <Reveal className="mt-10 grid gap-8 md:grid-cols-2 md:gap-16">
      <div className="border-t border-white/15 pt-6"><h3 className="text-2xl font-[520] text-fg">Rethink the work.</h3><p className="mt-3 max-w-md text-base leading-relaxed text-fg-2">A machine need not copy a sailor. Start with the job, then find a simpler way to do it.</p></div>
      <div className="border-t border-white/15 pt-6"><h3 className="text-2xl font-[520] text-fg">Fit the world as it is.</h3><p className="mt-3 max-w-md text-base leading-relaxed text-fg-2">Change only what the ship manager controls. Ports, cranes and other vessels stay as they are.</p></div>
    </Reveal>
  </section>
);
